import type { CityConfig } from "../city-template/types";

export const decorahConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Iowa Vital Records (Birth, Death, Marriage)", href: "https://hhs.iowa.gov/programs/vital-records", description: "Official Iowa Department of Health and Human Services vital records office in Des Moines" },
    { label: "Winneshiek County Recorder — Birth, Death &amp; Marriage", href: "https://www.winneshiekcounty.iowa.gov/", description: "Winneshiek County Recorder — local vital records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Decorah",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "decorah",
  route: "/decorah",
  title: "Emergency Passport Decorah, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Decorah, IA — as fast as 24 hours. Serving Winneshiek County and Northeast Iowa. A+ BBB rated registered State Dept. courier serving the Luther College and Vesterheim Norwegian heritage region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Decorah, IA",
  heroSubtitle: "Luther College study abroad trip to Norway with two weeks notice? Nordic Fest family reunion passport expired? Northeast Iowa river valley traveler heading to Canada? We help Decorah residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Decorah%20Iowa%20nestled%20in%20the%20Upper%20Iowa%20River%20valley%20lush%20green%20bluffs%20Norwegian%20heritage%20architecture%20Vesterheim%20Museum%20Luther%20College%20campus%20limestone%20buildings%20winding%20river%20through%20scenic%20Northeast%20Iowa%20Driftless%20Region%20golden%20hour%20warm%20sunset%20light%20professional%20drone%20photography%20natural%20beauty&width=1800&height=700&seq=decorah-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Decorah Iowa Norwegian heritage Upper Iowa River valley at golden hour",
  geoPosition: "43.3033;-91.7857",
  geoPlacename: "Decorah, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 280 miles southeast of Decorah via US-52/I-90",
  },
  nearbyCitiesZips: [
    { name: "Decorah", zips: "52101" },
    { name: "Waukon", zips: "52172" },
    { name: "Cresco", zips: "52136" },
    { name: "Postville", zips: "52162" },
    { name: "West Union", zips: "52175" },
    { name: "Calmar", zips: "52132" },
    { name: "Ossian", zips: "52161" },
    { name: "Spring Grove", zips: "55974" },
    { name: "Lansing", zips: "52151" },
    { name: "New Hampton", zips: "50659" },
    { name: "Prairie du Chien", zips: "53821" },
    { name: "La Crosse", zips: "54601–54603" },
    { name: "Winona", zips: "55987" },
    { name: "Rochester", zips: "55901–55906" },
    { name: "Dubuque", zips: "52001–52003" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Northeast Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Driftless Region Coverage", desc: "Serving Decorah, Waukon, Cresco, and the Upper Iowa River Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Dubuque, IA", route: "/dubuque" },
    { name: "Fast passport renewal in Iowa City, IA", route: "/iowa-city" },
    { name: "Emergency passport help in Cedar Rapids, IA", route: "/cedar-rapids" },
    { name: "Urgent passport services in La Crosse, WI", route: "/la-crosse" },
    { name: "Same-day passport help in Rochester, MN", route: "/rochester" },
    { name: "Passport courier services in Chicago, IL", route: "/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Decorah remotely via secure courier. We do not have a walk-in office in Decorah — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Winneshiek County and Northeast Iowa.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Winneshiek County and the Upper Iowa River Valley including Allamakee, Howard, and Fayette counties",
  serviceAreaIntro: "From the Norwegian heritage of Vesterheim Museum and the limestone bluffs along the Upper Iowa River to the Luther College campus and its renowned Nordic studies program, from the charming downtown of Decorah with its award-winning breweries to the agricultural communities of Calmar and Ossian, from the river town of Lansing on the Mississippi to the Amish country around Waukon — Fast Passport Center serves the entire Northeast Iowa Driftless Region. We regularly help travelers from Winneshiek County, the Decorah area, and the Upper Iowa River Valley get their passports fast without the 280-mile drive to Chicago.",
  nearbyCitiesIntro: "We serve all Decorah neighborhoods and the surrounding Northeast Iowa area including Waukon, Cresco, Postville, West Union, Calmar, Ossian, Spring Grove, Lansing, New Hampton, and the Tri-State communities of Prairie du Chien, La Crosse, Winona, Rochester, and Dubuque. If you are anywhere in Winneshiek County, the Driftless Region, or the Upper Mississippi River Valley, we have you covered.",
  howItWorksIntro: "Most Decorah travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Decorah travelers often face a 4.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Decorah and Winneshiek County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Decorah? Here are the most common ones we hear from Northeast Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Decorah travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Ingrid L.",
      location: "Decorah, IA",
      rating: 5,
      text: "Luther College Norway semester abroad — passport expired, departure in 5 days. Fast Passport Center had my renewal in 28 hours. Jeg er så takknemlig! Saved my Nordic studies dream.",
      service: "Passport Renewal",
    },
    {
      name: "Erik B.",
      location: "Postville, IA",
      rating: 5,
      text: "Nordic Fest trip to Bergen with the whole family. Three kids needed passports fast. Fast Passport Center handled all four in 4 days. The Driftless Region's best-kept secret.",
      service: "Child Passport",
    },
    {
      name: "Karen S.",
      location: "Waukon, IA",
      rating: 5,
      text: "Emergency business trip to Frankfurt. Lost my passport — absolute panic. Fast Passport Center got my replacement in 26 hours. My boss was stunned. Northeast Iowa hero service.",
      service: "Emergency Passport",
    },

  ],
  facilities: [
    {
      id: "decorah-1",
      name: "Decorah Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "401 Heivly St",
      city: "Decorah",
      state: "IA",
      zip: "52101",
      phone: "(563) 382-4211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Decorah",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Decorah facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "decorah-2",
      name: "Winneshiek County Recorder",
      type: "County Recorder Passport Acceptance",
      address: "201 W Main St",
      city: "Decorah",
      state: "IA",
      zip: "52101",
      phone: "(563) 382-5787",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Decorah Courthouse",
      website: "https://www.winneshiekcounty.iowa.gov",
      websiteLabel: "Winneshiek County Recorder",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "decorah-3",
      name: "Waukon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "107 W Main St",
      city: "Waukon",
      state: "IA",
      zip: "52172",
      phone: "(563) 568-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles northeast of Decorah",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Allamakee County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "decorah-4",
      name: "Cresco Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "110 2nd Ave W",
      city: "Cresco",
      state: "IA",
      zip: "52136",
      phone: "(563) 547-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Decorah",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Howard County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "decorah-5",
      name: "West Union Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 S Vine St",
      city: "West Union",
      state: "IA",
      zip: "52175",
      phone: "(563) 422-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Decorah",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fayette County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "decorah-6",
      name: "La Crosse Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "425 State St",
      city: "La Crosse",
      state: "WI",
      zip: "54601",
      phone: "(608) 784-2111",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "60 miles northeast of Decorah",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Regional facility serving the Tri-State area. Extended hours available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Decorah photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Winneshiek County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Decorah applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Northeast Iowa families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Decorah travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Decorah." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Decorah address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Decorah before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Decorah for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Decorah?", a: "Fast Passport Center offers fast passport renewal in Decorah in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Decorah?", a: "The nearest regional passport agency to Decorah is the Chicago Passport Agency, approximately 280 miles southeast via US-52/I-90. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Decorah without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Decorah?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 4.5 hours from Decorah — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Winneshiek County and Northeast Iowa residents." },
    { q: "Do you serve the entire Driftless Region?", a: "Absolutely. Fast Passport Center serves the entire Northeast Iowa Driftless Region including Decorah, Waukon, Cresco, Postville, West Union, Calmar, Ossian, and surrounding areas. Our courier service works seamlessly from any address in Winneshiek County, Allamakee County, or Howard County." },
    { q: "Can I expedite a child passport in Decorah?", a: "Yes. Fast Passport Center expedites child passports in Decorah for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Northeast Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Decorah with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Decorah", address: "1798 Old Stage Rd, Decorah, IA 52101", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Oneota Community Food Co-op Pharmacy", address: "312 W Water St, Decorah, IA 52101", hours: "Mon–Sat: 8AM–7PM, Sun: 10AM–6PM", website: "https://oneotacoop.com/" },
    { name: "Walmart Supercenter — Waukon", address: "1045 11th Ave SW, Waukon, IA 52172", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — La Crosse", address: "425 State St, La Crosse, WI 54601", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Decorah",
      address: "306 W Water St, Decorah, IA 52101",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services at the Winneshiek County Courthouse. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Waukon",
      address: "110 N Court St, Waukon, IA 52172",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Allamakee County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Cresco",
      address: "102 S Park Pl, Cresco, IA 52136",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Howard County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DEH",
      name: "Decorah Municipal Airport",
      distance: "3 miles southeast of downtown Decorah",
      address: "1929 IA-9, Decorah, IA 52101",
      note: "General aviation airport serving Winneshiek County. About 10 minutes from downtown Decorah.",
      flightUrl: "https://www.decorahia.org/airport",
      flightLabel: "DEH Airport",
      featured: true,
    },
    {
      code: "LSE",
      name: "La Crosse Regional Airport",
      distance: "60 miles northeast of Decorah",
      address: "2850 Airport Dr, La Crosse, WI 54603",
      note: "Regional airport with direct flights to Chicago and Minneapolis. About 1 hour 15 minutes from Decorah.",
      flightUrl: "https://www.cityoflacrosse.org/airport",
      flightLabel: "LSE Airport",
      featured: false,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "80 miles northwest of Decorah",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Regional airport with direct flights to major hubs. About 1 hour 30 minutes from Decorah.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "RST Airport",
      featured: false,
    },
  ],
};